import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches available vehiculos and conductores for a given movilizacion time range.
 * Marks items as ocupado if they overlap with other approved movilizaciones.
 */
export const useFleetOptions = ({ enabled, fechaInicio, fechaFin, excludeMovId }) => {
  const [vehiculos, setVehiculos] = useState([]);
  const [conductores, setConductores] = useState([]);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const params = {
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
      exclude_mov_id: excludeMovId,
      only_available: true,
    };
    Promise.all([
      axios.get(`${API_URL}/api/vehiculos`, { params, withCredentials: true }),
      axios.get(`${API_URL}/api/conductores`, { params, withCredentials: true }),
    ])
      .then(([v, c]) => {
        if (cancelled) return;
        setVehiculos(v.data);
        setConductores(c.data);
      })
      .catch(() => {
        /* Silently ignore — UI will fall back to manual text input */
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, fechaInicio, fechaFin, excludeMovId]);

  return { vehiculos, conductores };
};

/**
 * Builds a handler that autopopulates vehiculo text fields when a catalog item is selected.
 */
export const buildVehiculoHandler = (vehiculos, setFormData) => (vehId) => {
  if (vehId === '__custom__') {
    setFormData((p) => ({ ...p, vehiculo_id: '' }));
    return;
  }
  const v = vehiculos.find((x) => x.id === vehId);
  setFormData((p) => ({
    ...p,
    vehiculo_id: vehId,
    vehiculo: v
      ? `${v.alias ? v.alias + ' · ' : ''}${v.patente}${v.marca_modelo ? ' · ' + v.marca_modelo : ''}`
      : p.vehiculo,
  }));
};

/**
 * Builds a handler that autopopulates conductor text fields when a catalog item is selected.
 */
export const buildConductorHandler = (conductores, setFormData) => (condId) => {
  if (condId === '__custom__') {
    setFormData((p) => ({ ...p, conductor_id: '' }));
    return;
  }
  const c = conductores.find((x) => x.id === condId);
  setFormData((p) => ({
    ...p,
    conductor_id: condId,
    conductor: c ? c.nombre_completo : p.conductor,
    telefono_conductor: c ? c.telefono : p.telefono_conductor,
  }));
};
